// Import SCSS
import './../scss/app.scss';
// import './admin';
import './login';

// Bootstrap
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

// PhotoSwipe
import './photoswipe.js';

// Event calendar
import {Calendar as EventCalendar} from './calendar.js';
window['EventCalendar'] = EventCalendar;

// import Custom JS
import './custom-js';
